/**
 * 폼 구성요소로 제공 가능한 프로바이더 목록입니다.
 */
import mps from "./providers/mps";

const providers = {
    MPS: 'mps',
};

const elements = {
    mps,
};

export {providers, elements};
